const tag = {
  addtag: 'Add Tag',
  manage: 'Manage Tags',
  create_new: 'Create new Tag',
  ok: 'OK',
  create_tag: 'Create Tag',
  delete_tag: 'Delete Tag',
  edit_tag: 'Edit Tag',
  form: {
    tag_name: 'Tag Name',
    color: 'Color',
    in_sidebar: 'Add to Sidebar',
    save: 'Save'
  }
}

export default tag
